export interface GrowthCycleTemplate {
    id?: string;
    name: string;
    cellCount: number;
    daysInGermination: number;
    daysInPropagation: number;
    daysInHighDensity?: number;
    raftTypeHighDensity?: Raft;
    expectedHighDensityRafts?: number;
    expectedHighDensityCellsRemaining?: number;
    daysInFinishedSpacing: number;
    raftTypeFinishedSpacing: Raft;
    expectedFinishedSpacingRafts?: number;
    expectedFinishedSpacingCellsRemaining?: number;
    harvestType: Harvest;
    harvestInterval?: number;
    notes?: string;
}

export interface Raft {
    cellSpacing: number;
}

export enum Harvest {
    Once = 'ONCE',
    Many = 'MULTIPLE',
}
